import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';
import { WikiContentFile } from '../../models/wiki/wiki-content.model';

@Injectable({ providedIn: 'root' })
export class WikiContentService {
  private readonly http = inject(HttpClient);
  private readonly content = signal<WikiContentFile | null>(null);
  private readonly failed = signal(false);
  private loadStarted = false;

  readonly loaded = computed(() => this.content() !== null);
  readonly loadFailed = computed(() => this.failed());

  readonly navGroups = computed(() => this.content()?.navGroups ?? []);
  readonly topics = computed(() => this.content()?.topics ?? {});
  readonly employeeGettingStartedTopicIds = computed(
    () => this.content()?.employeeGettingStartedTopicIds ?? ['introduction', 'login'],
  );

  ensureLoaded(): void {
    if (this.loadStarted) {
      return;
    }
    this.loadStarted = true;

    this.http.get<WikiContentFile>('/wiki/wiki-content.json').subscribe({
      next: (data) => this.content.set(data),
      error: () => this.failed.set(true),
    });
  }
}
